module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.1.1-rc.10-76.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.1.1-rc.10.md
// module id = 493
// module chunks = 358